<section class="cta-section">
  <div class="cta-inner">
    <h2 class="cta-heading">
      {{ t.subfooter[0] }} <br />
      {{ t.subfooter[1] }}
    </h2>
    <a [routerLink]="['/', lang, 'contactus']" class="btn-contact">
      {{ t.Contact }}
      <svg
        class="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M5 12H19"
          stroke="#EE2D39"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 5L19 12L12 19"
          stroke="#EE2D39"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  </div>
</section>
